<template>
    <div style="height: 89vh;overflow-y: auto;">
        <div v-if="sta.mallver=='v1'">
            <Tabs v-show="getUserId.length>0" id="cards" v-model="tabsDefault" type="line" :animated="false" @on-click="checkExtRenewal">
                <TabPane :disabled="isTeamMember" label="账号等级" name="name1">
                    <MemberPackage ref="memberPackage" @cleanCart="cleanCart" @add-cart="cartSave" @check-vip="getIsVip" @isTeamUser="setTeamUser" />
                </TabPane>
                <TabPane :disabled="!isVip" :label="label" name="name2" style="width:100%;margin:auto;">
                    <h2 v-if="(this.sta.accounttype===2 || this.sta.accounttype===3)">请与单位管理员联系</h2>
                    <h2 v-else>升级VIP权限，体验更多惊喜</h2>
                    <p style="text-align: center;"><span style="font-size: 14px;display: inline-block;vertical-align: middle;">选择账号等级包：</span></p>
                    <div :class="radioproducts.length>3?'productscroll':'productnoscroll'">
                        <RadioGroup v-model="radioProduct" @on-change="rgChange">
                            <div v-for="item in radioproducts">
                                <Radio :key="item.orderid" :label="item.label">
                                </Radio>
                            </div>
                        </RadioGroup>
                    </div>
                    <br />
                    <div class="flex-content">
                        <swiper ref="myswiper" class="swiper" :options="swiperOption">
                            <swiper-slide v-for="item in plist" :key="item.funccode">
                                <div class="flex-content-card">
                                    <Card id="extcards" :padding="0">
                                        <p slot="title">
                                            <span>{{item.funcname}}</span>
                                            <span style="font-size: 14px;color:#19be6b;float:right;">（已购：{{item.alreadybought}}）</span>
                                        </p>
                                        <p slot="title" class="card-title-desc">
                                            {{item.funcdesc}}
                                        </p>
                                        <div v-if="item.alreadybought<item.maxactive">
                                            <CellGroup>
                                                <Cell>
                                                    <span class="ivu-cell-label">购买数量</span>
                                                    <span style="font-size: 10px;color:#c5c8ce;">{{item.desc}}</span>
                                                    <div v-if="item.funccode!=='000012' && item.funccode!=='000011'" style="width:100px;text-align: right;" slot="extra">
                                                        {{item.orderNumber}}
                                                    </div>
                                                    <div slot="extra" v-else>
                                                        <InputNumber :disabled="item.funccode!=='000012' && item.funccode!=='000011'" size="default" :max="item.maxactive-item.alreadybought" :min="item.minctive" v-model="item.orderNumber" @on-change="numberchange($event,item)"></InputNumber>
                                                    </div>
                                                </Cell>
                                                <Cell>
                                                    <span class="ivu-cell-label">购买时长</span>
                                                    <span slot="extra">
                                                        {{orderDays}} 天
                                                    </span>
                                                </Cell>
                                            </CellGroup>
                                            <br />
                                            <div class="product_price" style="text-align: center;">售价：<span style="font-weight:bold;font-size: 16px;color:#ed4014;">￥ {{(item.price*item.orderNumber*orderDays).toFixed(2)}}</span></div>
                                            <div v-if="item.alreadybought<item.maxactive" class="addcart">
                                                <div v-if="sta.accounttype===1 || sta.accounttype===4">
                                                    <Button :disabled="item.orderNumber===0" type="primary" @click="goPurchase(item)">{{isCurrentyear?'购买':'续购'}}</Button> <Button :disabled="item.orderNumber===0" type="primary" @click="addToShoppingCart(item)">加入购物车</Button>
                                                </div>
                                                <div v-else></div>
                                            </div>
                                            <br />
                                        </div>
                                        <div v-else style="text-align: center;line-height: 280px;"> <Button type="success" @click="goRenewal" style="width: 150px;">已购</Button></div>
                                    </Card>
                                </div>
                            </swiper-slide>
                            <!--  <div class="swiper-pagination" slot="pagination"></div> -->
                        </swiper>
                    </div>
                    <div v-if="this.plist&&this.plist.length>3" style="text-align:center;"><Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="slidePrev">上一页</Button>
                        <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="slideNext">下一页</Button></div>
                    
                </TabPane>
                <!--    <TabPane label="其他" name="name3"></TabPane> -->
            </Tabs>
            <div class="cartDiv" :style="{display:tabsDefault==='name1'?'none':'block' }">
                <Button ref="btnCart" :class="isShowCartStyle?'goShoppingCart':'goShoppingCartDefault'" size="large" type="error" icon="md-cart" @click="showModal">去购物车结算 {{shoppingCart.length}}</Button>
            </div>
        </div>
         <div v-else style="padding:0px;">
            <NewStore ref="mynewstore"/>
        </div>
        <Modal v-model="modalCart" :styles="{top: '50px'}" width="80" :mask-closable="false" @on-cancel="cancel">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="md-cart" size="18" />
                <span>购物车</span>
            </p>
            <div style="text-align:center">
                <ShoppingCart ref="r_cart" :tData="shoppingCart" @remove="removeItem" @agreement="getAgreement" />
            </div>
            <div slot="footer">
                <Button style="left:15px;position:absolute;" type="error" size="large" @click="cleanCart">清空购物车</Button>
                <Button type="text" size="large" @click="cancel">取消</Button>
                <Button :disabled="shoppingCart.length===0" type="primary" size="large" @click="checkOrder">去支付</Button>
            </div>
        </Modal>
        <Modal v-model="modalPurchase" footer-hide :mask-closable="false" width="700">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>购买VIP升级权限</span>
            </p>
            <Card class="pay-content" id="paycard" style="border:1px solid #d6bb5c;">
                <!-- <div class="actionPayTitle"></div> -->
                <div slot="title">
                    <p class="pay-title">{{currentPurchaseData?currentPurchaseData.funcname:''}}</p>
                    <p class="card-explain" style="color:#C57E00">购买数量：{{currentPurchaseData?currentPurchaseData.orderNumber:''}}</p>
                    <p style="font-size: 14px;color:#C57E00;">订购时长：
                        <span> {{orderDays}} 天</span>
                    </p>
                </div>
                <!--  升级包优惠 -->
                <div style="width: 450px;margin-left:auto;text-align: left;">
                    <Card :bordered="false" dis-hover style="background-color:#FEE5A7;">
                        <CellGroup>
                            <Cell v-for="item in discountdescdetail" :title="item.discountdesc" :key="item.id" :selected="item.selected">
                                <Icon v-if="item.selected" type="md-checkmark-circle" color="#19be6b" size="22" slot="extra" />
                                <span v-else slot="extra">未满足</span>
                            </Cell>
                        </CellGroup>
                    </Card>
                </div>
            </Card>
            <Divider orientation="right">优惠信息</Divider>
            <div style="text-align:right;padding-right: 10px;height: 100px;">
                <Coupon ref="mycoupon" @on-check="onCouponChecked" :isCouponShow=true />
            </div>
            <div class="pay-change">
                <Divider orientation="right">支付方式</Divider>
                <!-- <p style="height:30px;"></p> -->
                <div class="pay-btn-content">
                    <!--   <span style="text-decoration: line-through;color:#c5c8ce;font-size: 14px;padding-right: 20px;">原价:{{orderamount}}元</span> -->
                    <span class="card-price">实际支付：{{actualamount}} 元</span>
                </div>
                <RadioGroup v-model="payChange" style="padding-top: 10px;">
                    <span>选择支付方式：</span>
                    <Radio label="微信" border>
                        <i class="iconfont" style="color: #19c105;">&#xe650;</i>
                        <span style="color: #19c105;">微信</span>
                    </Radio>
                    <!-- <Radio label="支付宝" border>
                        <i class="iconfont" style="color: #00aaee;">&#xe618;</i>
                        <span style="color: #00aaee;">支付宝</span>
                    </Radio> -->
                </RadioGroup>
            </div>
            <div class="invoiceContent">
                <span>发票信息：</span>
                <span v-if="invoiceType===1">普通发票</span>
                <span v-else-if="invoiceType===2">增值税专用发票</span>
                <span>{{invoiceHeaderName}}</span>
                <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="showInvoice">修改</Button>
            </div>
            <!-- <div class="agreement-content">
                <Checkbox style="margin-right: 0px;" v-model="agreementChecked">我已认真阅读协议</Checkbox>《<span class="agreement-user">用户协议</span>》
            </div> -->
            <br />
            <div style="text-align: right;"><Button type="default" size="default" @click="closevippaymodal">关闭</Button> <Button type="primary" class="pay-btn" @click="directPay_checkOrder">去支付</Button></div>
        </Modal>
        <Modal v-model="modalInvoice" width="700" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>修改发票信息</span>
            </p>
            <div>
                <Invoice ref='myInvoice' :isModal="true" />
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelInvoice">取消</Button>
                <Button type="primary" size="large" @click="getInvoiceInfo">确定</Button>
            </div>
        </Modal>
        <QR ref="QRPayModal" @paySuccess="payComplete" @showAgreement="showPackageAgreement" />
        <PackageAgreement ref="mypkgagreement" @onAccept="acceptAgreement" :isConfirm="true" />
        
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import scart from "./shoppingcart.vue"
import member from "./member_package.vue"
import invoice from "./myinvoice.vue"
import coupon from './coupon.vue'
import packageAgreement from './product_package_agreement.vue'
import eventBus from "../../components/common/event_bus.js"
import moment from 'moment'
import qrModal from './qrpay.vue'
import newstore from './newstore.vue'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            showNewStore: true,
            isTeamMember: false,
            //changerow:null,
            copydata: '',
            memberLevelChkInfo: null,
            isCurrentyear: true,
            checkedRadioData: {
                label: '',
                orderid: '',
                productcode: '',
            },
            swiperOption: {
                simulateTouch: false,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                slidesPerView: 3,
                centerInsufficientSlides: true,
                spaceBetween: 20,
                //slidesPerGroup: 3,
                disabledClass: 'my-button-disabled',
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                // on: {
                //     observerUpdate: function() {
                //          //alert('observer监测到了不可描述的事情发生');
                //     },
                // },
                //initialSlide: 1,
            },
            orderamount: 0,
            actualamount: 0,
            discountdescdetail: [],
            myInvoiceHeader: {
                bankaccount: "",
                bankname: "",
                headercode: "",
                headername: "个人",
                headertype: 1,
                invoiceTotal: 0,
                mobilenumber: "",
                officeaddress: "",
                postaddress: "",
                postemail: "",
                postmobile: "",
            },
            invoiceHeaderName: '个人',
            invoiceType: 1,
            sonheadertype: 1,
            modalInvoice: false,
            orderDays: 0,
            radioproducts: [],
            radioProduct: '',
            orderid: '',
            base64str: '',
            productId: '',
            productOrderId: '',
            tabsDefault: 'name1',
            isDirectPay: false, //是否是直接购买
            isAgreement: true,
            isShowCartStyle: false,
            modalCart: false,
            modalPurchase: false,
            modalPay: false,
            payChange: '微信',
            agreementChecked: false,
            label: (h) => {
                return h('div', [
                    h('span', 'VIP升级权限'),
                    // h('Badge', {
                    //     props: {
                    //         count: 3
                    //     }
                    // })
                ])
            },
            plist: [],
            package_upload: null,
            package_anyscreen: null,
            package_filestore: null,
            package_download: null,
            shoppingCart: [],
            currentPurchaseData: null,
            totalBill: 0,
            desc1: '',
            desc2: '【种子用户】单独购买享9折，同时购买【文件仓库】享85折，同时购买【云擎下载】享受8折',
            desc3: '',
            desc4: '',
            cartItems: [],
            isVip: false,
            yearsScreenData: [{
                id: '30001',
                title: '一年',
                value: 1,
                desc: '原价'
            }, {
                id: '30002',
                title: '二年',
                value: 2,
                desc: '优惠',
            }, {
                id: '30003',
                title: '三年',
                value: 3,
                desc: '优惠',
            }],
        }
    },
    mounted() {
        //console.log('页面更新=====>')
        if (this.sta.mallver === 'v1') {
            let tabValue = this.$route.params.tabindex
            this.tabsDefault = tabValue
            console.log(tabValue)
            this.checkExtRenewal(tabValue)
            //重置动画
            this.$refs.btnCart.$el.addEventListener("animationend", this.listener)
        }

    },
    watch: {
        '$route': 'routeChanged',
        'getUserId': 'loginLoadProduct'
    },
    components: {
        "ShoppingCart": scart,
        "MemberPackage": member,
        "Coupon": coupon,
        "QR": qrModal,
        "Invoice": invoice,
        'PackageAgreement': packageAgreement,
        'NewStore': newstore,
    },
    created() {
        // let d=moment("2021-09-15 23:59:59", "YYYY-MM-DD")
        // console.log(d.format("YYYY-MM-DD"))
        this.cartGet()
        //this.getUserPermission()
    },
    computed: {
        countDays() {
            return function(data) {
                let per = 0
                if (data) {
                    per = data.remainingday / 365 * 100
                }
                console.log(per)
                return per
            }
        },
        countDate() {
            return function(t1, t2) {
                let st = moment(t1).format("YYYY-MM-DD")
                let et = moment(t2).format("YYYY-MM-DD")
                let result = st + ' 至 ' + et

                return result
            }
        },
        ...mapGetters(['getUserId', 'sta'])
    },
    methods: {
        setTeamUser() {
            console.log('setTeamUser')
            this.tabsDefault = 'name2'
            this.checkExtRenewal('name2')
            this.isTeamMember = true
        },
        showCouponPrice(value) {
            this.actualamount = value.item.amount
            this.orderamount = value.item.oriamount
            console.log(value)
        },
        onCouponChecked(chkinfo) {
            this.memberLevelChkInfo = chkinfo
            if (chkinfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.actualamount, this.showCouponPrice)
            } else {
                this.$refs.mycoupon.clean()

                //还原到原始价格
                let _copy = JSON.parse(this.copydata)
                this.actualamount = _copy.oriprice

                //this.loadDefaultPackages(this.userleveldata)
            }
        },

        //切换主套餐包事件
        rgChange(value) {
            //清空购物车
            this.cleanCart()

            let index = this.radioproducts.findIndex(p => p.label === value)
            console.log(index)
            if (index === 0) {
                this.isCurrentyear = true
            } else {
                this.isCurrentyear = false
            }

            let member = this.radioproducts.find(p => p.label === value)
            this.checkedRadioData = member
            console.log(member)
            this.getProductPackages(member)

        },
        slideNext() {
            this.$refs.myswiper.swiper.slideNext()
            console.log(this.$refs.myswiper.swiper)
        },
        slidePrev() {
            this.$refs.myswiper.swiper.slidePrev()
        },
        acceptAgreement() {
            console.log('同意协议2===>')
        },
        showPackageAgreement() {
            this.$refs.mypkgagreement.show()
        },
        cancelInvoice() {
            this.modalInvoice = false
        },
        closevippaymodal() {
            this.modalPurchase = false
        },
        getInvoiceInfo() {
            this.$refs.myInvoice.$refs.formData.validate((valid) => {
                if (valid) {
                    if (this.$refs.myInvoice.formData.headertype == 1) {
                        this.$refs.myInvoice.formData.headercode = ''
                        this.$refs.myInvoice.formData.officeaddress = ''
                        this.$refs.myInvoice.formData.mobilenumber = ''
                        this.$refs.myInvoice.formData.bankname = ''
                        this.$refs.myInvoice.formData.bankaccount = ''
                        // this.$refs.myInvoice.formData.postaddress = ''
                        // this.$refs.myInvoice.formData.postemail = ''
                        // this.$refs.myInvoice.formData.postmobile = ''
                    }
                    this.sonheadertype = Number(this.$refs.myInvoice.formData.headertype)
                    console.log(this.sonheadertype);
                    this.$refs.myInvoice.remData = JSON.parse(JSON.stringify(this.$refs.myInvoice.formData))
                    this.$refs.myInvoice.remheadertype = this.$refs.myInvoice.formData.headertype
                    let _invoiceType = this.$refs.myInvoice.invoicetype
                    let invoiceHeader = { ...this.$refs.myInvoice.formData }
                    //this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
                    this.invoiceHeaderName = this.$refs.myInvoice.formData.headertype == 1 ? '个人' : '单位'
                    this.invoiceType = Number(_invoiceType)
                    this.myInvoiceHeader = invoiceHeader
                    this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
                    this.modalInvoice = false
                    // console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
                } else {
                    this.$Message.error('请填写必填项！');
                    return
                }
            })

        },
        // getInvoiceInfo() {
        //     this.$refs.myInvoice.$refs.formData.validate((valid) => {
        //         if (valid) {
        //             let _invoiceType = this.$refs.myInvoice.invoicetype
        //             let invoiceHeader = { ...this.$refs.myInvoice.formData }
        //             this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
        //             this.invoiceType = Number(_invoiceType)
        //             this.myInvoiceHeader = invoiceHeader
        //             this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
        //             this.modalInvoice = false
        //             console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
        //         } else {
        //             this.$Message.error('请填写必填项!');
        //             return
        //         }
        //     })

        // },
        // getInvoiceInfo() {
        //     let _invoiceType = this.$refs.myInvoice.invoicetype
        //     let invoiceHeader = { ...this.$refs.myInvoice.formData }
        //     this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
        //     this.invoiceType = Number(_invoiceType)
        //     this.myInvoiceHeader = invoiceHeader
        //     this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
        //     this.modalInvoice = false
        //     console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
        // },
        showInvoice() {
            this.modalInvoice = true
            this.$refs.myInvoice.invoicetype = '1'
            this.$refs.myInvoice.invoiceTotal = this.actualamount
            //this.$refs.myInvoice.getInvoice()
        },
        getUserPermission() {
            console.log('获取用户permission')
            constJ.reqGetUserPermission().then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {

                }
            })
        },
        payComplete() {
            console.log(this.checkedRadioData)
            //更新升级权限列表状态
            Promise.all([this.getProductPackages(this.checkedRadioData)]).then(res => {
                //通知top_header刷新用户数据
                eventBus.$emit('user-flashToken')
            });
            this.cleanCart()
        },
        //购买单个扩展包获取优惠信息
        showDirectPayDiscount(item) {
            console.log(item)
            let ext_func = []
            // this.productId = store.state.user.myvippackage[0].productcode
            // this.productOrderId = store.state.user.myvippackage[0].orderid
            if (item.alreadybought < item.maxactive) {
                let arr = {
                    func_code: item.funccode,
                    func_name: item.funcname,
                    number: item.orderNumber
                }
                ext_func.push(arr)
                let po = {
                    productcode: this.productId,
                    productorderid: this.productOrderId,
                    paytype: 30,
                    extfunc: ext_func
                }
                console.log(po)
                constJ.reqPackageDiscount(po).then(res => {
                    console.log(res)
                    if (res.rltcode === 1 && res.rtncode === 1) {
                        //根据返回的折扣，修改价格
                        let pkgdiscount = {
                            orderamount: res.result.orderamount,
                            actualamount: res.result.actualamount
                        }
                        this.orderDays = res.result.days
                        this.discountdescdetail = res.result.discountdescdetail
                        this.orderamount = pkgdiscount.orderamount
                        this.actualamount = pkgdiscount.actualamount

                        //拷贝原始价格
                        let _copy = {
                            oriprice: this.actualamount
                        }
                        this.copydata = JSON.stringify(_copy)

                        //显示ui
                        this.modalPurchase = true

                        //读取发票信息
                        this.$refs.myInvoice.getInvoice()
                        //this.$refs.myInvoice.invoiceTotal=this.actualamount


                        //获取发票信息
                        // var that = this
                        // this.$refs.myInvoice.getInvoice().then(function(resp) {
                        //     console.log('单个购买读取发票信息完成...')
                        //     that.getInvoiceInfo()
                        // })
                        // var _that = this
                        // this.$refs.myInvoice.getInvoice().then(function(resp) {
                        //     console.log(resp)
                        //     console.log('读取发票信息完成...')
                        //     if (resp.rltcode === 1 && resp.rtncode === 1) {
                        //         _that.getInvoiceInfo()
                        //     } else {
                        //         //设置初次默认
                        //         _that.$refs.myInvoice.formData.headertype = '1'
                        //         _that.$refs.myInvoice.formData.headername = '个人'
                        //         //_that.getInvoiceInfo()
                        //     }

                        // })
                    }
                })
            }
        },

        showCartPackageDiscount(cartItem) {
            let ext_func = []
            // this.productId = store.state.user.myvippackage[0].productcode
            // this.productOrderId = store.state.user.myvippackage[0].orderid
            cartItem.forEach(function(item) {
                if (item.alreadybought < item.maxactive) {
                    let arr = {
                        func_code: item.funccode,
                        func_name: item.funcname,
                        number: item.orderNumber
                    }
                    ext_func.push(arr)
                }

            })
            let po = {
                productcode: this.productId,
                productorderid: this.productOrderId,
                paytype: 30,
                extfunc: ext_func
            }
            //console.log(po)
            constJ.reqPackageDiscount(po).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.orderDays = res.result.days
                    //根据返回的折扣，修改价格
                    let pkgdiscount = {
                        orderamount: res.result.orderamount,
                        actualamount: res.result.actualamount,
                        discountdescdetail: res.result.discountdescdetail
                    }
                    this.shoppingCart.pkgdiscount = pkgdiscount
                    this.$refs.r_cart.show(this.shoppingCart)

                }
            })

        },

        getPackageDiscountInfo(packageList) {
            let ext_func = []
            packageList.forEach(function(item) {
                if (item.alreadybought < item.maxactive) {
                    let arr = {
                        func_code: item.funccode,
                        func_name: item.funcname,
                        number: 1
                    }
                    ext_func.push(arr)
                }

            })
            let po = {
                productcode: this.productId,
                productorderid: this.productOrderId,
                paytype: 30,
                extfunc: ext_func
            }

            constJ.reqPackageDiscount(po).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.orderDays = res.result.days
                    //this.discountdescdetail=res.result.discountdescdetail
                }
            })
        },
        getProductPackages(item) {
            this.radioproducts = []
            let radios = []
            radios = store.state.user.myvippackage
            var that = this
            //console.log(item)
            if (item && item.productcode === '') {
                console.log("getProductPackages=================>")
                //设置当前套餐信息
                this.productId = store.state.user.myvippackage[0].productcode
                this.productOrderId = store.state.user.myvippackage[0].orderid

                //默认项
                let st1 = moment(radios[0].starttime).format("YYYY-MM-DD")
                let et1 = moment(radios[0].endtime).format("YYYY-MM-DD")
                this.radioProduct = radios[0].productname + '(' + st1 + '至' + et1 + ')'
                console.log(this.radioProduct)

                //默认项
                this.checkedRadioData.label = this.radioProduct
                this.checkedRadioData.orderid = this.productOrderId
                this.checkedRadioData.productcode = this.productId
                console.log(this.checkedRadioData)
            } else {
                this.productId = item.productcode
                this.productOrderId = item.orderid
            }





            //console.log(this.checkedRadioData)
            radios.forEach(function(item) {
                let r = {}
                let st = moment(item.starttime).format("YYYY-MM-DD")
                let et = moment(item.endtime).format("YYYY-MM-DD")
                r.label = item.productname + '(' + st + '至' + et + ')'
                r.orderid = item.orderid
                r.productcode = item.productcode
                that.radioproducts.push(r)
            })


            //this.radioproduct=store.state.user.myvippackage[0]
            console.log(this.radioproducts)
            constJ.reqProductPackages(this.productId, this.productOrderId).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    let list = []
                    //如果会员等级是种子用户，则已购数量设置为1
                    list = res.items.funcs
                    if (this.checkedRadioData.productcode === '000001') {
                        let li = list.find(p => p.funccode === '000009')
                        if (li.alreadybought === 0) {
                            li.alreadybought = 1
                        }
                    }
                    //添加订购数量字段，默认1
                    if (list.length > 0) {
                        list.forEach(function(item) {
                            item.orderNumber = 1
                        })
                    }

                    this.plist = list
                    this.orderDays = res.items.days
                    console.log(this.plist, this.orderDays)
                }
            })
        },
        checkUserLogin(value) {
            console.log('checkuserlogin---------->')
            console.log(value)
            if (value && value.length > 0) {
                return true
            } else {
                return false
            }
        },
        loginLoadProduct(value) {
            console.log('这是扩展包===>')
            this.$nextTick(() => {
                if (this.checkUserLogin(value)) {
                    if (store.state.user.mallver === 'v1') {
                        this.$refs.memberPackage.getProducts()
                        //设置扩展包为可选
                        this.getIsVip(true)
                    }
                    if (store.state.user.mallver === 'v2') {
                        this.$refs.mynewstore.getProductsV2()
                    }
                }
            })

        },
        routeChanged() {
            console.log('routeChanged======>')
        },
        showRenewalModal() {
            eventBus.$emit("user-renewal") //go renewal
        },
        showVipBoard() {
            eventBus.$emit("user-vipboard") //go vipboard
        },
        goRenewal() {
            //this.showVipBoard()
        },
        tabClick(value) {
            // if (value === 'name2') {
            //     this.getProductPackages()
            // }
        },
        checkExtRenewal(value) {
            if (value === 'name2') {
                this.cleanCart()
                if (this.checkedRadioData) {
                    this.getProductPackages(this.checkedRadioData)
                } else {
                    this.getProductPackages()
                }
            } else if (value === 'name1') {

            }

            // let pkgs = store.state.user.myextentionpackage
            // this.plist.forEach(function(item) {
            //     let i = pkgs.findIndex(p => p.name === item.name)
            //     console.log(i)
            //     if (i >= 0) {
            //         item.isPurchased = true
            //     }
            // })
        },
        // countScreenTotal(item) {


        // },
        numberchange(value, row) {
            console.log(value, row)
        },
        yearsScreenChange(value, row) {

        },
        getIsVip(value) {
            this.isVip = value
        },
        payFailure() {
            this.modalPay = false
        },
        paySuccess() {
            console.log('paySuccess,update===>')
            if (this.isDirectPay) {
                this.upDatePackageDirectPaySuccess()
            } else {
                this.cartPaySuccess()
            }
            //更新续费状态
            this.checkExtRenewal()
        },
        upDatePackageDirectPaySuccess() {
            this.modalPay = false
            this.$Message.success('升级包支付成功')
            let ar = []
            ar.push(this.currentPurchaseData)
            store.state.user.myextentionpackage = ar
        },
        //购物车支付成功
        cartPaySuccess() {
            let pt = this.$refs.r_cart.payType
            console.log(this.cartItems)
            this.modalPay = false
            this.$Message.success('支付成功')

            //暂存store,后续修改为从后端读取

            // if (pt === 1) {
            //     store.state.user.myvippackage = this.cartItems
            //     //更新为付费会员状态
            //     this.$refs.memberPackage.checkIsVip()
            // } else if (pt === 2) {
            //     store.state.user.myextentionpackage = this.cartItems
            // }

            //支付成功,清空购物车
            this.cleanCart()
        },
        cleanCart() {
            this.shoppingCart = []
            this.$refs.r_cart.totalPrice = 0
            this.$refs.r_cart.payPrice = 0
            this.$refs.r_cart.clearCart()
            this.$refs.r_cart.couponClean()
            store.state.user.shoppingcart = []
        },
        getAgreement(value) {
            //console.log(value)
            this.isAgreement = value
        },

        //下单前检查优惠码和运营商信息,可以强制下单
        directPay_checkOrder() {
            let r = this.$refs.mycoupon.getConfirmInfo()
            if (r.iswarning) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>' + r.rltdesc + '</p>',
                    cancelText: "返回",
                    okText: "下单",
                    onOk: () => {
                        this.directPay()
                    },
                    onCancel: () => {
                        return
                    }
                });
            } else {
                this.directPay()
            }
        },

        directPay() {
            console.log('expkg directpay===>')
            // let total = this.currentPurchaseData ? (this.currentPurchaseData.price * this.currentPurchaseData.orderNumber * this.orderDays).toFixed(2) : ''
            this.totalBill = this.actualamount
            //this.modalPay = true
            this.modalPurchase = false

            let da = this.currentPurchaseData
            //console.log(da)
            //订购的扩展包
            let ext_func = []
            let arr = {
                func_code: da.funccode,
                func_name: da.funcname,
                number: da.orderNumber
            }
            ext_func.push(arr)
            let _invoice = {
                invoicetype: this.invoiceType,
                invoiceheader: this.myInvoiceHeader,
            }

            //购物车优惠码信息
            let promocode = {
                couponcode: this.$refs.mycoupon.formCustom.couponValue,
                agentcode: this.$refs.mycoupon.formCustom.agencies
            }

            //下单
            let po = {
                productcode: this.productId,
                productorderid: this.productOrderId,
                paytype: this.$refs.r_cart.payChange === "微信" ? 30 : 20,
                extfunc: ext_func,
                couponcode: promocode.couponcode,
                agentcode: promocode.agentcode,
                invoice: _invoice,
            }
            //console.log(po)
            this.order(po)



        },
        //下单前检查优惠码和运营商信息,可以强制下单
        checkOrder() {
            let r = this.$refs.r_cart.$refs.mycoupon.getConfirmInfo()
            if (r.iswarning) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>' + r.rltdesc + '</p>',
                    cancelText: "关闭",
                    okText: "下单",
                    onOk: () => {
                        this.goUnityPay()
                    },
                    onCancel: () => {
                        return
                    }
                });
            } else {
                this.goUnityPay()
            }
        },
        goUnityPay() {
            this.isDirectPay = false
            //总金额
            let total = this.$refs.r_cart.payPrice
            let pc = this.$refs.r_cart.payChange
            console.log('goUnityPay.total:' + total)
            this.cartItems = this.$refs.r_cart.table_data
            this.totalBill = total

            //this.modalPay = true


            //购物车优惠码信息
            let promocode = {
                couponcode: this.$refs.r_cart.$refs.mycoupon.formCustom.couponValue,
                agentcode: this.$refs.r_cart.$refs.mycoupon.formCustom.agencies
            }
            //购物车发票信息
            let _invoice = {
                invoicetype: this.$refs.r_cart.invoiceType,
                invoiceheader: this.$refs.r_cart.myInvoiceHeader,
            }
            //若是会员包结算，则提交到会员页面去下单
            if (this.cartItems[0].pkgclass === 0) {
                //会员购物车结算时修改实际支付金额
                this.cartItems[0].total = this.totalBill
                this.cartItems[0].paychange = pc
                this.cartItems[0].promocode = promocode
                this.$refs.memberPackage.cartPay(this.cartItems[0], _invoice)
                return
            }
            //处理购物车订购扩展包
            //订购的扩展包
            let ext_func = []
            this.cartItems.forEach(function(item) {
                let arr = {
                    func_code: item.funccode,
                    func_name: item.funcname,
                    number: item.orderNumber
                }
                ext_func.push(arr)
            })

            //下单
            let po = {
                productcode: this.productId,
                productorderid: this.productOrderId,
                paytype: this.$refs.r_cart.payChange === "微信" ? 30 : 20,
                extfunc: ext_func,
                couponcode: promocode.couponcode,
                agentcode: promocode.agentcode,
                invoice: _invoice,
            }
            this.order(po)

            //关闭购车，清空购车
            this.modalCart = false
            this.cleanCart()

            //this.saving()
            //console.log(store.state.user.shoppingcart)

        },
        order(po) {
            constJ.reqCreatePackageOrder(po).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.base64str = `data:image/png;base64,` + res.result.strdata
                    this.orderid = res.result.orderid
                    let finalprice = res.result.actualAmount
                    let da = {
                        base64str: this.base64str,
                        orderid: this.orderid,
                        payChange: this.payChange,
                        totalBill: finalprice, //this.totalBill
                    }
                    console.log('po============>')
                    console.log(da)
                    this.$refs.QRPayModal.show(da)
                    this.getOrderContract(this.orderid)
                } else {
                    this.$Message.warning(res.rltdesc)
                    return
                }
            })
        },
        //获取合同信息
        getOrderContract(orderid) {
            //獲取合同信息
            console.log('获取升级包合同orderid:' + orderid)
            constJ.reqGetOrderContract(orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.showQRAndCheckPayStatus()
                    this.$refs.mypkgagreement.createdata(res.item)
                }
            })
        },
        //直接购买
        goPurchase(item) {
            console.log(item)
            let number = 1
            this.isDirectPay = true
            let current_product = null
            let pkg = JSON.stringify(item)
            current_product = JSON.parse(pkg)
            current_product.total = (item.price * item.orderNumber * this.orderDays).toFixed(2) //Number(this.countScreenTotal(item))
            if (item.orderNumber) {
                number = item.orderNumber
            }
            // else {
            //     number = item.minctive
            // }
            current_product.orderNumber = number

            //初始化单项的总价
            // if (current_product.total === 0) {
            //     current_product.total = Math.round(current_product.price * current_product.number * current_product.remainingday * item.orderYears)
            // }

            this.currentPurchaseData = current_product

            //获取购买单个产品的优惠信息
            this.showDirectPayDiscount(current_product)
            //this.modalPurchase = true

            //清空coupon
            this.$refs.mycoupon.clean()

        },
        listener() {
            console.log('run lisener==>')
            this.isShowCartStyle = false
            //remove
            //this.$refs.btnCart.$el.removeEventListener("animationend",this.listener)
        },
        //设定购物车会员优惠
        getProductDiscount(code) {
            let discountList = []
            //var that =this
            constJ.reqProductDiscountList(code).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    discountList = res.item
                    //选中一年的优惠
                    discountList.forEach(function(item) {
                        if (item.salenumber === 1) {
                            item.selected = true
                            //设置优惠项
                            //that.shoppingCart.productdiscount=item
                        } else {
                            item.selected = false
                        }
                    })
                    //this.modalPurchase = true
                    //弹出购物车
                    console.log('弹出购物车===>')
                    this.shoppingCart.productdiscount = discountList
                    this.$refs.r_cart.show(this.shoppingCart)
                }
            })
        },
        showcart() {
            console.log(this.shoppingCart)
            //class,0=购买会员
            if (this.shoppingCart && this.shoppingCart.length > 0) {
                this.modalCart = true
                //pkgclass===0不会提交到购物车
                if (this.shoppingCart[0].pkgclass === 0) {
                    this.getProductDiscount(this.shoppingCart[0].id)
                } else {
                    this.showCartPackageDiscount(this.shoppingCart)
                }
            } else {
                this.$Message.warning('购物车里没有任何商品，请先添加')
                return
            }


            //this.$refs.r_cart.show(this.shoppingCart)
        },
        showModal() {

            this.showcart()
        },
        buy() {
            // this.modalCart = false
            // this.saving()
        },
        cancel() {
            this.modalCart = false
            this.$refs.r_cart.couponClean()
        },
        // cleanCart() {
        //     this.shoppingCart = store.state.user.shoppingcart = []
        //     this.$refs.r_cart.totalPrice = 0
        //     this.showcart()
        // },
        removeItem(id) {
            let index = this.shoppingCart.findIndex(item => item.id === id)
            this.shoppingCart.splice(index, 1)
            this.saving()
            this.showcart()
        },
        saving() {
            store.state.user.shoppingcart = this.shoppingCart
        },
        cartGet() {
            this.shoppingCart = store.state.user.shoppingcart
            console.log("get cart==>")
            console.log(this.shoppingCart)
        },
        cartSave(item) {
            console.log('saving===>' + this.shoppingCart.length)
            console.log(item)
            this.isShowCartStyle = true
            if (item) { //如果是分屏多次购买则叠加数量和金额
                let origin = store.state.user.shoppingcart.find(p => p.id === item.id)
                if (origin) {
                    origin.orderNumber = Number(item.orderNumber)
                    origin.total = (origin.orderNumber * origin.price * 365).toFixed(2)
                } else {
                    this.shoppingCart.push(item);
                    store.state.user.shoppingcart = this.shoppingCart
                }


            }
        },

        addToShoppingCart(item) {
            console.log(item)
            let number = 1
            let current_product = null
            let pkg = JSON.stringify(item)
            current_product = JSON.parse(pkg)
            current_product.total = (item.price * item.orderNumber * this.orderDays).toFixed(2) //Number(this.countScreenTotal(item))
            if (item.orderNumber) {
                number = item.orderNumber
            }
            // else {
            //     number = item.minctive
            // }
            current_product.orderNumber = number
            current_product.title = item.funcname
            current_product.desc = item.funcdesc
            current_product.id = item.funccode
            current_product.remainingday = this.orderDays
            //产品类型0=会员,其他=扩展包
            current_product.pkgclass = 1
            //购买扩展包需要记录productcode，productorderid

            // current_product.remainingday = 365 * item.orderYears
            // current_product.expirationDate = moment().add(current_product.remainingday, 'days').format("YYYY-MM-DD");
            // if (current_product.total === 0) {
            //     current_product.total = (current_product.price * current_product.number * current_product.remainingday).toFixed(2)
            // }
            this.cartSave(current_product);
        },

    }
}
</script>
<style lang="less" scoped>
// 产品说明
.ivu-cell-label {
    font-size: 14px;
}

#cards/deep/.ivu-card-head {
    background-color: #FEE7AA;
}

#extcards/deep/.ivu-card-head {
    background-color: #FEE7AA;
    height: 100px;
}

#cards/deep/.ivu-tabs-ink-bar {
    height: 1px;
}

#cards/deep/.ivu-cell-selected {
    color: white;
    background-color: #5cadff;
}

#cards/deep/.ivu-card {
    /*min-width: 200px;*/
    height: 380px;
}

#cards/deep/.addcart {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 50px;
}



#cards/deep/.product_price {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 110px;
}


#cards/deep/.ivu-tabs-nav-scroll {
    //margin:auto;
    display: flex;
    justify-content: center;

    .ivu-tabs-nav {
        .ivu-tabs-ink-bar {
            //display: none; 
        }
    }
}

//控制card标题换行
#cards/deep/.ivu-card-head p,
.ivu-card-head-inner {
    white-space: normal;
    overflow: inherit;
}

#paycard {
    background-color: #FEE5A7;
    overflow: hidden;
}

#paycard/deep/.ivu-card-head {
    border-bottom: 1px solid #e0cc98;
}

.actionPayTitle {
    background-color: #F4C466;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 250px;
    left: 350px;
    //border: 1px sloid red;
    border-radius: 0%;
    transform: translate(50px, 50px);
    -webkit-transform: rotate(45deg);
    z-index: 1;
}

.actionTitle {
    background-color: #FF4D60;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 0px;
    right: 0px;
    border: 1px sloid red;
    border-radius: 50%;
    transform: translate(50px, -50px);
}

.actionText {
    position: absolute;
    top: 0px;
    right: 5px;
    color: white;
}

@keyframes myfirst {
    from {
        background: #ffdbde;
    }

    to {
        background: #FF4D60;
    }
}

.goShoppingCartDefault {}

.goShoppingCart {
    animation: myfirst 1s;
    -webkit-animation: myfirst 1s;
    /* Safari 与 Chrome */
}

.cartDiv {
    position: absolute;
    bottom: 80px;
    width: 100%;
    text-align: center;
    z-index: 999;
}

//弹出支付
.card-explain {
    text-align: center;
    line-height: 18px;
    font-size: 16px;
    height: 18px;
    margin-top: 20px;
}

.pay-content {
    border: 1px solid #ccc;
    margin: 1% 10% 2% 10%;
    padding: 1% 5% 0% 5%;
    text-align: center;
}

.pay-title {
    font-size: 20px;
    color: #f55d54;
    height: 20px;
}

.pay-change {
    text-align: right;
}

.pay-explain {
    height: 90px;
    font-size: 10px;
    line-height: 20px;
    text-align: center;
    margin-top: 10px;
}

.agreement-content {
    margin-top: 30px;
    font-size: 10px;
    text-align: center;
}

.agreement-user {
    font-size: 10px;
    color: #4386f5;
    cursor: pointer;
}

.pay-btn-content {
    margin-top: 10px;
    text-align: right;
    font-size: 14px;
}

.pay-btn {
    margin-left: 20px;
}

@font-face {
    font-family: 'iconfont';
    /* project id 1804652 */
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot');
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff') format('woff'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.svg#iconfont') format('svg');
}

.iconfont {
    font-size: 16px;
    font-family: 'iconfont';
    margin-right: 10px;
}


.card-price {
    text-align: right;
    padding-right: 10px;
    line-height: 20px;
    font-size: 20px;
    color: #2d8cf0;
    height: 20px;
    color: #ed4014;
}


//pay modal
.vipmodal/deep/.ivu-modal-body {
    padding: 0px;
}

.vipmodal/deep/.ivu-modal-header {
    background-color: #FEE7AA;
}


h2 {
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.scentitle {
    font-size: 10px;
    color: #ccc;
    line-height: 50px;
    text-align: center;
}

.card-title-desc {
    font-size: 12px;
    color: #808695;
    height: 20px;
    line-height: 20px;
    margin-top: 5px;
}




.qr-code-img {
    /*height: 256px;*/
    width: 256px;
    /*margin-bottom: 30px;*/
}


//选择主套餐包
.productscroll {
    text-align: center;
    margin-bottom: 10px;
    display: block;
    margin: 0 auto;
    width: 400px;
    height: 66px;
    overflow-y: scroll;
}

.productnoscroll {
    text-align: center;
    margin-bottom: 10px;
    display: block;
}



/*发票信息*/
.invoiceContent {
    margin-top: 5px;
    text-align: right;

    span {
        padding-left: 10px;
    }
}




//swiper
.flex-content {
    //display: flex;
    margin: 0 22%;
    padding: 5px;
    justify-content: space-evenly;

}

.swiper-slide:first-child {
    //border: 2px solid #2d8cf0;
}

.swiper-slide-check {
    border: 2px solid #2d8cf0;
}

.swiper-slide-default {
    border: none;
}
</style>